export default __webpack_public_path__ + "static/media/bannerdek.8edd585d.png";